import './App.css';
import React from "react";
import AllBabyNamesFunction from "./Components/BabyNamesFiles.js";
import BabyNamesInput from './Components/BabyNamesInput';
import FavouriteNames from './Components/FavouriteNames';


function App() {

  return (
    <div className="wrapper">
      
    
      <AllBabyNamesFunction />
    </div>
  );
}
export default App;
